import _pick from 'lodash/pick';
import { transformAvailabilityDataToAPIShape } from '../ManageServices.helpers';

const resourceAllowedAttributes = [
  'name',
  'availability_recurrence',
  'time_blocks',
  'availability_overrides',
  'service_ids',
];

export const transformResourceData = data =>
  _pick(transformAvailabilityDataToAPIShape(data), resourceAllowedAttributes);
